import { render, staticRenderFns } from "./SettingsImportContacts.vue?vue&type=template&id=92733b82&scoped=true&"
import script from "./SettingsImportContacts.vue?vue&type=script&lang=js&"
export * from "./SettingsImportContacts.vue?vue&type=script&lang=js&"
import style0 from "./SettingsImportContacts.vue?vue&type=style&index=0&id=92733b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92733b82",
  null
  
)

export default component.exports